import {RootState} from "../store";

export const getOrderNumber = (state: RootState) => state.order?.number;

export const orderSelector = (state: RootState) => state.order;

export const orderPendingSelector = (state: RootState) => state.order?.isPending;